import themes from "./themes";
import RouteManager from "./routes";
import { Provider } from "react-redux";
import { store, persistor } from "store";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import SessionExpiry from "components/sessionExpiry";
import { PersistGate } from "redux-persist/integration/react";
import { StyledEngineProvider, CssBaseline } from "@mui/material";
import NoInternetConnection from "components/noInternetConnection";
import React from "react";


function App() {
  const themeCustomization = {
    opened: true,
    borderRadius: 12,
    defaultId: "default",
    fontFamily: `'Roboto', sans-serif`,
    isOpen: [], // for active default   menu
  };
  
  React.useEffect(() => {
    if (process.env.REACT_APP_MODE === 'production') {
      console.log = () => { };
      console.error = () => { };
      console.warn = () => { };
      console.warn = () => { };
      console.info = () => { };
      console.debug = () => { };

      // Disable right-click

      document.addEventListener('contextmenu', (e) => e.preventDefault());

      function ctrlShiftKey(e, keyCode) {
        return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
      }

      document.onkeydown = (e) => {
        // Disable F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
        if (
          e?.keyCode === 123 ||
          ctrlShiftKey(e, 'I') ||
          ctrlShiftKey(e, 'J') ||
          ctrlShiftKey(e, 'C') ||
          (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0))
        )
          return false;
      };
    }
  }, [])


  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes(themeCustomization)}>
        <CssBaseline />
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter>
              <RouteManager />
              <SessionExpiry />
            </BrowserRouter>
            <ToastContainer />
            <NoInternetConnection />
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
